import { useQuery } from 'react-query';

import { UploadEligibilityResponse } from '../../../../backend/src/matter/procedural-timeline/dto/upload-eligibility.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetProceduralTimelineUploadEligibility = (matterId?: string, enabled = true) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<UploadEligibilityResponse, Error>(
    [QueryEntity.ProceduralTimelineUploadEligibility, { matterId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/procedural-timeline/upload-eligibility`,
        fetchConfigGET,
      );
      if (!res.ok) throw new Error('Failed to fetch procedural timeline upload eligibility');
      return res.json();
    },
    { enabled: !!matterId && enabled, refetchOnWindowFocus: false },
  );
};
